/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  PriceProvidersRepositoryQuoteToken,
  PriceProvidersRepositoryQuoteTokenInterface,
} from "../PriceProvidersRepositoryQuoteToken";

const _abi = [
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class PriceProvidersRepositoryQuoteToken__factory {
  static readonly abi = _abi;
  static createInterface(): PriceProvidersRepositoryQuoteTokenInterface {
    return new utils.Interface(
      _abi
    ) as PriceProvidersRepositoryQuoteTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceProvidersRepositoryQuoteToken {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PriceProvidersRepositoryQuoteToken;
  }
}
